export default function isSuccess(status) {
  return status === 'success' || (status >= 200 && status < 400);
}
